export function index(userId, companyId, {offset = 0, limit = 10})
{
    return axios.get(route('api.manage.users.notifications', {userId}) + '?filter[company_id]=' + companyId,
        { params: {offset, limit} })
        .then(response => response.data);
}

export function markAllRead(userId)
{
    return axios.post(route('api.manage.users.notifications.markAllRead', {userId}));
}

export function markAllUnread(userId)
{
    return axios.post(route('api.manage.users.notifications.markAllUnread', {userId}));
}

export function update(notificationId, data)
{
    return axios.patch(route('api.manage.notifications.update', {notificationId}), data)
        .then(response => response.data);
}
